module.exports = __webpack_public_path__ + "static/media/1.d0fc5868.jpg";